export default [
  {
    id: 0,
    name: 'Cirurgião',
  },
  {
    id: 1,
    name: '1º auxiliar',
  },
  {
    id: 2,
    name: '2º auxiliar',
  },
  {
    id: 3,
    name: '3º auxiliar',
  },
  {
    id: 4,
    name: '4º auxiliar',
  },
]
